import React, { memo } from 'react';

const Card = memo(({ 
  children,
  title,
  subtitle,
  className = '',
  style = {},
  padding = 'medium',
  shadow = 'medium',
  ...props 
}) => {
  const paddings = {
    none: { padding: '0' },
    small: { padding: '12px' },
    medium: { padding: '16px' },
    large: { padding: '24px' }
  };

  const shadows = {
    none: { boxShadow: 'none' },
    small: { boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)' },
    medium: { boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)' },
    large: { boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)' }
  };

  const cardStyles = {
    backgroundColor: 'white',
    borderRadius: '8px',
    border: '1px solid #e5e7eb',
    ...paddings[padding],
    ...shadows[shadow],
    ...style
  };

  const headerStyles = {
    marginBottom: '16px',
    paddingBottom: '12px',
    borderBottom: '1px solid #f3f4f6'
  };

  const titleStyles = {
    fontSize: '18px',
    fontWeight: '600',
    color: '#111827',
    margin: 0,
    marginBottom: subtitle ? '4px' : 0
  };

  const subtitleStyles = {
    fontSize: '14px',
    color: '#6b7280',
    margin: 0
  };

  return (
    <div className={`card ${className}`} style={cardStyles} {...props}>
      {(title || subtitle) && (
        <div style={headerStyles}>
          {title && <h3 style={titleStyles}>{title}</h3>}
          {subtitle && <p style={subtitleStyles}>{subtitle}</p>}
        </div>
      )}
      {children}
    </div>
  );
});

export default Card;

Card.displayName = 'Card';
